import { Button, Filter, Filters, Sort, SortOrder, Search, TooltipV2 } from '@cimplico/components';
import { useFirmContext } from '../../providers/FirmProvider';

export type SortResult = {
    queryString: string;
    currentSortState: {
        order: SortOrder;
        option?: string | undefined;
    };
};

export type FilterResults = {
    queryString: string;
    currentFilterState: Filters;
};

type PrimaryPageActionsProps = {
    id: string;
    primaryButtonLabel: string;
    secondaryButton?: boolean;
    secondaryButtonLabel?: string;
    sortOptions: string[] | { id: string; label: string }[];
    defaultSortOption?: string;
    defaultSortOrder?: 'asc' | 'desc';
    filterOptions: Filters;
    disablePrimaryButton?: boolean;
    disabledPrimaryButtonHint?: string;
    primaryButtonTooltipPosition?: 'top' | 'right' | 'bottom' | 'left';
    disableSecondaryButton?: boolean;
    disabledSecondaryButtonHint?: string;
    filtersLoading?: boolean;
    primaryButtonLoading?: boolean;
    onSortChange: (query: string, sort: { order: 'asc' | 'desc'; option?: string }) => void;
    onFilterChange: (query: string, filters: Filters) => void;
    onSearchChange: (search: string) => void;
    onPrimaryButtonClick: () => void;
    onSecondaryButtonClick?: () => void;
};

function PrimaryPageActions({
    id,
    sortOptions,
    filterOptions,
    secondaryButton,
    primaryButtonLabel,
    secondaryButtonLabel,
    disablePrimaryButton,
    disabledPrimaryButtonHint = '',
    primaryButtonTooltipPosition,
    disableSecondaryButton,
    disabledSecondaryButtonHint = '',
    filtersLoading = false,
    onFilterChange,
    onPrimaryButtonClick,
    onSearchChange,
    onSortChange,
    onSecondaryButtonClick,
    defaultSortOption,
    defaultSortOrder = 'asc',
    primaryButtonLoading,
}: PrimaryPageActionsProps): JSX.Element {
    function handleSortChange(result: SortResult): void {
        onSortChange(result.queryString, result.currentSortState);
    }

    function handleFilterChange(result: FilterResults): void {
        onFilterChange(result.queryString, result.currentFilterState);
    }

    function handleSearchChange(result: string): void {
        onSearchChange(result);
    }

    function handlePrimaryClick(): void {
        onPrimaryButtonClick();
    }

    return (
        <div className="flex gap-4 items-center">
            {/* <TextInput onChange={handleSearchChange} placeholder="Search..." icon={<SearchIcon />} /> */}
            <Search onChange={handleSearchChange} placeholder="Search..." />
            <Sort
                onChange={handleSortChange}
                sortOptions={sortOptions}
                enableV2Query={process.env.REACT_APP_MOCK_API !== 'true'}
                defaultSortOption={defaultSortOption}
                defaultSortOrder={defaultSortOrder}
            />
            <Filter
                onChange={handleFilterChange}
                filters={filterOptions}
                isLoading={filtersLoading}
                enableV2Query={process.env.REACT_APP_MOCK_API !== 'true'}
                menuPosition="left"
            />
            {secondaryButton && (
                <TooltipV2 message={disabledSecondaryButtonHint} disabled={!disabledSecondaryButtonHint}>
                    <Button
                        onClick={onSecondaryButtonClick}
                        type="secondary"
                        label={secondaryButtonLabel}
                        size="sm"
                        disabled={disableSecondaryButton}
                    />
                </TooltipV2>
            )}
            <TooltipV2 message={disabledPrimaryButtonHint} disabled={!disabledPrimaryButtonHint} position={primaryButtonTooltipPosition}>
                <Button
                    onClick={handlePrimaryClick}
                    type="primary"
                    label={primaryButtonLabel}
                    size="sm"
                    disabled={disablePrimaryButton}
                    isLoading={primaryButtonLoading}
                />
            </TooltipV2>
        </div>
    );
}
export default PrimaryPageActions;
